import React from "react";
import DrawerRemoveObjectComponent from "./DrawerRemoveObjectComponent";
import DrawerGoBackComponent from "./DrawerGoBackComponent";
import { CurrentDrawerOpenType } from "state/slices/RightDrawerSlice";
import CMRSliderComponent, { SliderType } from "./CMRSliderComponent";
import BSUPatientHeader from "./BSUPatientHeader";

const DrawerTrolleyComponent = (): JSX.Element => {
    return (
        <>
            <BSUPatientHeader title={"Trolley"} />
            <CMRSliderComponent type={SliderType.Trolley} title={"Rotate"} />
            <DrawerRemoveObjectComponent
                classes={"mt-35 onlyDesktop"}
                type={"trolley"}
                payload={"trolley"}
            />
            <DrawerGoBackComponent classes="onlyDesktop" type={CurrentDrawerOpenType.Trolley} />
        </>
    );
};

export default DrawerTrolleyComponent;
